/** Normalize option to { value, label } */
export const norm = (opt) =>
  typeof opt === "string"
    ? { value: opt, label: opt }
    : { value: opt.value ?? opt.label, label: opt.label ?? opt.value };

export const defaultCategoryOptions = [
  "Daily Sale",
  "Cash Sale",
  "Profit",
  "Rental Income",
  "Recovery",
];

/** Build filtersConfig from legacy props: filters (string[]) and filterOptions (object keyed by label) */
export function buildConfigFromLegacy(filters = [], filterOptions = {},categories) {
  return filters.map((key) => {
    const label = typeof key === "string" ? key : key.label ?? key.id ?? key;
    const opts = filterOptions[label];
    const hasOptions = Array.isArray(opts) || (opts && Array.isArray(opts?.options));
    let options = Array.isArray(opts) ? opts : opts?.options ?? [];
    if (label === "Category" && options.length === 0) options =  categories ? categories : defaultCategoryOptions;
    if (label === "Status" && options.length === 0) options = ["Paid", "Unpaid"];
    if (label === "Method" && options.length === 0) options = ["Cash", "Bank"];
    if (label === "Sort" && options.length === 0) options = ["Newest", "Oldest","Amount (Low to High)", "Amount (High to Low)"];
    let type = "checkbox";
    if (label === "Category" || (hasOptions && options.length > 5)) type = "category";
    else if (label === "Date") type = "date";
    else if (label === "Sort") type = "sort";
    else if (label === "Amount") type = "amount";
    else if (label === "Keywords" || label === "Search") type = "keywords";
    return { id: label, label, type, options };
  });
}
